import * as React from "react";
import * as $ from "jquery";
import { CardType,  GameTokenUtil, TokenUtil, ICard } from "./Card";
import { Dnd, IDragSource, IDragImage, IDropTarget, IDrop } from "./Dnd";
import { TokenComponent } from "./Token";
import {CardToolbarComponent } from "./CardToolbarComponent";
import {IDeckSettings} from "./DeckComponent";
import {ZoomedCardComponent} from "./ZoomedCardComponent";
import { IDeck, IDeckToolbarSettings, Deck } from "./Deck";
import { DeckUtil } from "./DeckUtil";
import { CardUtil } from "./CardUtil";

interface IInvestigatorHandState {
    zoomed: boolean;
    shuffling:boolean;
}

export interface IInvestigatorHandProps {
    deck: IDeck;
    settings?: IDeckSettings;
    onChanged: () => void;
}
export class InvestigatorHandComponent extends React.Component<IInvestigatorHandProps, IInvestigatorHandState> implements IDragSource, IDropTarget {
    ul: HTMLUListElement;
    deck:Deck;
    constructor(props: IInvestigatorHandProps) {
        super(props);
        let toolbarSettings: IDeckToolbarSettings = {};
        if (this.props.settings) {
            toolbarSettings = this.props.settings.toolbar;
        }
        if (toolbarSettings.align === undefined) {
            toolbarSettings.align = "right";
        }
        if (this.props.deck)
            CardUtil.flip(this.props.deck.cards, true);
        this.deck = new Deck(toolbarSettings);
        this.deckChanged = this.deckChanged.bind(this);
        this.state = { zoomed: false ,shuffling:false};
    }
    toggleZoom(): void {
        this.setState({ zoomed: !this.state.zoomed });
    }
    shuffleStart(): void {
        this.setState({ shuffling: true });
    }
    shuffleEnd(): void {
        this.setState({ shuffling: false });
    }

    private topCardDiv: HTMLDivElement;

    getDropElement(): HTMLElement {
         return this.topCardDiv;
    }

    allowDrop(dragType: string, effectAllowed: string): string {
        if (DeckUtil.hasCard(this.props.deck) && /token\/.+/.test(dragType)) {
            return Dnd.move;
        }
        return null;
    }
    onDrop(drop: IDrop): boolean {
        if (/token\/(.+)/.test(drop.dragType)) {
            const name = RegExp.$1;
            if (!name) return false;

            const gt = GameTokenUtil.parse(name);
            const card = this.props.deck.cards[0];
            const token = TokenUtil.getToken(card, gt);
            token.x = drop.targetX;
            token.y = drop.targetY;
            token.canBeMoved = true;
            token.number++;
            this.props.onChanged();
            return true;
        }
        return false;
    }
    onDragComplete(): void {
        this.props.deck.cards.splice(0, 1);
        this.props.onChanged();
    }

    getDragImage(dragType: string): IDragImage {
        return null;
    }

    getDragItem() {
        return this.props.deck.cards[0];
    }
    move(back?: boolean) {
        if (!DeckUtil.hasCard(this.props.deck)) return;
        if (back) {
            CardUtil.backToTop(this.props.deck.cards);
        } else {
            CardUtil.topToBack(this.props.deck.cards);
        }
        const $ul = $(this.ul);
        $ul.addClass("disable-hover");
        this.props.onChanged();
        setTimeout(() => { $ul.removeClass("disable-hover") }, 500);
    }
    moveToTop(index: number) {
        if (0 === index) {
            return;
        }
        const card = DeckUtil.remove(this.props.deck, index);
        DeckUtil.addToTop(this.props.deck, card);
        const $ul = $(this.ul);
        $ul.addClass("disable-hover");
        this.props.onChanged();
        setTimeout(() => { $ul.removeClass("disable-hover") }, 500);
    }
    deckChanged(s: string) {
        if (s === Deck.onChangeShuffleStart) {
            this.setState({ shuffling: true });
        } else if (s === Deck.onChangeShuffleEnd) {
            this.setState({ shuffling: false });
        } else if (s === Deck.onChangeToggleZoom) {
            this.setState({ zoomed: !this.state.zoomed });
        } else {
            this.props.onChanged();
        }
    }
    componentWillMount(): void {
       
        this.deck.onChange(this.deckChanged);
    }

    componentWillUnmount(): void {
        this.deck.removeOnChange(this.deckChanged);
    }

    render() {
        this.deck.setDeck(this.props.deck);
        let cards: JSX.Element[] = null;
        let tokens: JSX.Element[] = null;
        let cssClasses = "investigator-hand";
        if (this.state.shuffling) {
            cssClasses += " shuffling";
        }
        
        let zoomedCard: ICard = null;
        if (this.deck.hasCard()) {

            cards = [];
            if (this.state.zoomed) {
                zoomedCard = ({ ...this.deck.topCard() });
                zoomedCard.faceUp = true;
            }

            for (let i = this.props.deck.cards.length - 1; i >= 0; i--) {
                const c = this.props.deck.cards[i];
                let ce: JSX.Element;
                let cardCss = `deck ${CardUtil.getCardCss(c, true)}`;
                if (i===0) {
                    const dragType = `card/${CardType[c.type]}`;
                    let showTokens = true;
                    if (this.props.settings && this.props.settings.hideTokensOnFront)
                        showTokens = false;
                    if (showTokens && c.tokens && c.tokens.length) {
                        tokens = c.tokens.filter(t => t.number > 0).map((token) => {
                            return (<TokenComponent key={token.token} token={token}
                                valueChanged={(no) => {
                                    token.number += no;
                                    this.props.onChanged();
                                }}
                            />);
                        });
                    }
                    ce= (<li key={i}><div className={cardCss}
                        ref={(ref) => this.topCardDiv = ref}
                        draggable={true}
                        onDragStart={(e) => { Dnd.dragStart(e, this, dragType, Dnd.move); }}
                        onDragOver={(e) => { Dnd.dragOver(e, this); }}
                        onDrop={(e) => { Dnd.drop(e, this); }}
                    ><CardToolbarComponent  deck={this.deck} />
                        {tokens}</div></li>);
                } else {
                    ce= (<li key={i} onClick={() => this.moveToTop(i)}><div className={cardCss}></div></li>);
                }
                cards.push(ce);
            }
        }
        return (

            <div className={cssClasses} >
                <ul ref={(ref) => this.ul = ref}>{cards}</ul>
                {zoomedCard ? <ZoomedCardComponent deck={this.deck} horizontal={false} /> : null}

            </div>
        );
    }
}
